import React from "react";

import RatingStars from "@components/RatingStars";

import {DishReview} from "../interfaces";
import styles from "./ReviewListItem.scss";

type ReviewListItemProps = {
  review: DishReview;
};

const ReviewListItem = ({review}: ReviewListItemProps): JSX.Element => {
  return (
    <li className={styles.review}>
      <span className={styles.reviewName}>{review.user_name}</span>
      <RatingStars
        className={styles.reviewStars}
        averageRating={review.rating}
      />
      <span className={styles.reviewDate}>
        Ordered On {review.delivery_date}
      </span>
      <div className={styles.reviewComments}>{review.comments}</div>
    </li>
  );
};

export default ReviewListItem;
